import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";

export default class EndScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     */
     constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, mediatorManager, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, mediatorManager);
    }

    destroy() {
        super.destroy();
        
        // NB: make sure to delete expose of start button to avoid memory leaks
        delete window.actions?.clickEndButton;
    }

    initialize() {
        super.initialize();

        this._target.titleTextfield.text = this.getText("end.title");
        this._target.bodyTextfield.text = this.getText("end.body");

        this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this), this.getText("end.button"));
        
        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);

        this._exposeEndButton();

        this._animateIn(this._target);
    }

    _handleButtonClick() {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }

    // Used for integration testing by Equalture
    _exposeEndButton() {
        window.actions = window.actions || {};
        window.actions.clickEndButton = () => {
            return new Promise((resolve, reject) => {
                this._handleButtonClick();
                resolve();
            });
        }
    }

    _animateIn(target) {
        //animate elements in, if any
        let delay = ANIMATION_DELAY;
        for (let i = 0; i <= 30; i++) {
            const elem = target[`elem${i}`];
            if (!elem) {
                continue;
            }
            elem.visible = false;
            const scale = elem.scaleX;
            elem.scaleX = elem.scaleY = .01 * scale;
            createjs.Tween.get(elem)
                .wait(delay += ANIMATION_ELEMENT_INTERVAL)
                .set({ visible: true })
                .wait(1)
                .to({ scaleX: scale, scaleY: scale }, ANIMATE_POP_IN_DURATION, createjs.Ease.backOut);
        }
    }
}

const ANIMATION_ELEMENT_INTERVAL = 250;
const ANIMATION_DELAY = 250;
const ANIMATE_POP_IN_DURATION = 500;